export function DemoServiceLocal(api, localdata, postData) {
  /* console.log(
    "API:" + api + ",",
    "Local Stores:" + localdata + ",",
    "Post Data:" + postData
  ); */
  return;
}
